/* eslint-disable no-undef */
import Form from '../form_builder_2/form';
import './scss/order_cancellation_form.scss';

export default class OrderCancellationForm {
    constructor(el) {
        this.el = el;
        this.myAccount2 = window.HONDA.MyAccount2;
        this.location = el.dataset.location;
        this.param = el.dataset.param;
        this.confirmation = el.dataset.confirmation;
        this.orderSpecificationView = el.querySelector('.order_specification_view');
        this.orderErrorView = el.querySelector('.order_error_view');
        this.orderDetailsLoader = el.querySelector('.order-details-loader');
        this.container = el.querySelector('.order_container');
        this.optionalCta = el.querySelectorAll('.optional_feedback_buttons .optional_btn');
        this.additionalFeedbackWrapper = el.querySelector('.additional_feedback_wrapper');
        this.removeFeedbackCta = el.querySelector('.remove-feedback-link');
        this.orderNum = el.querySelector('.order_number');
        this.vehicleName = el.querySelector('.vehicle_name');
        this.template = _.template(el.querySelector('#order_summary_template').innerHTML.replaceAll('\\', ''));
        this.utils = {
            pipeToSpace: (str) => str.replaceAll('|', ' '),
            capitalize: (str) => str && str[0].toUpperCase() + str.slice(1),
        };
        this.init();
    }

    get() {
        return this.location === 'query' ? new URLSearchParams(window.location.search || '').get(this.param) : null;
    }

    init() {
        if (!this.myAccount2?.isLoggedIn()) {
            this.myAccount2.showModal({ close: false, guest: false });
        }
        OrderCancellationForm.hideElements([this.orderSpecificationView, this.orderErrorView]);
        OrderCancellationForm.showElements([this.orderDetailsLoader]);
        this.bind();
    }

    bind() {
        this.optionalCta.forEach((cta) => {
            cta.addEventListener('click', (event) => {
                event.preventDefault();
                this.optionalCta.forEach((btn) => btn.classList.remove('active'));
                event.target.classList.add('active');
                if (event.target.dataset.action === 'no') {
                    this.resetFeedbackForm();
                }
                this.additionalFeedbackWrapper.classList.toggle('hide', event.target.dataset.action === 'no');
            });
        });

        this.removeFeedbackCta.addEventListener('click', (event) => {
            event.preventDefault();
            this.optionalCta.forEach((cta) => cta.classList.remove('active'));
            this.optionalCta[0].classList.add('active');
            this.additionalFeedbackWrapper.classList.add('hide');
            this.resetFeedbackForm();
        });

        this.myAccount2?.addEventListener('login', () => {
            this.initForm();
            this.populate();
        });
    }

    resetFeedbackForm() {
        const selectElement = this.additionalFeedbackWrapper.querySelector('select');
        const textareaElement = this.additionalFeedbackWrapper.querySelector('textarea');

        if (selectElement) {
            selectElement.selectedIndex = 0;
        }

        if (textareaElement) {
            textareaElement.value = '';
        }
    }

    initForm() {
        if (!this.form) {
            this.form = new Form(this.orderSpecificationView, {
                onSubmit: this.onSubmit.bind(this),
                onSuccess: this.onSuccess.bind(this),
                onError: this.onError.bind(this),
            });
        }
    }

    onSubmit() {
        OrderCancellationForm.hideElements([this.orderSpecificationView]);
        OrderCancellationForm.showElements([this.orderDetailsLoader]);
    }

    onSuccess() {
        OrderCancellationForm.hideElements([this.orderDetailsLoader, this.orderSpecificationView]);
        this.form?.hideError();
        window.location.href = this.confirmation;
    }

    onError() {
        OrderCancellationForm.hideElements([this.orderDetailsLoader]);
        OrderCancellationForm.showElements([this.orderSpecificationView]);
        this.form?.showError(true);
    }

    async populate() {
        const orderId = this.get();
        if (orderId) {
            const orders = await window.HONDA.MyAccount2.client.getOrders() ?? [];
            if (orders.length) {
                const order = orders.find((o) => o.orderId === orderId);
                if (order?.summary) {
                    this.container.innerHTML = this.template({ order, utils: this.utils });
                    this.orderNum.querySelector('span').innerHTML = orderId;
                    this.vehicleName.querySelector('span').innerHTML = `${order?.summary?.labels?.modelName} ${order?.summary?.labels?.gradeName}`;
                    OrderCancellationForm.hideElements([this.orderErrorView]);
                    OrderCancellationForm.hideElements([this.orderDetailsLoader]);
                    OrderCancellationForm.showElements([this.orderSpecificationView]);
                } else {
                    this.showError();
                }
            } else {
                this.showError();
            }
        }
    }

    showError() {
        OrderCancellationForm.hideElements([this.orderDetailsLoader]);
        OrderCancellationForm.hideElements([this.orderSpecificationView]);
        OrderCancellationForm.showElements([this.orderErrorView]);
    }

    static showElements(elementList) {
        elementList.forEach((element) => {
            element.classList.remove('hide');
        });
    }

    static hideElements(elementList) {
        elementList.forEach((element) => {
            element.classList.add('hide');
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.order_cancellation_wrapper').forEach((el) => (el.classList.contains('load') ? new OrderCancellationForm(el) : null));
});
